import {css, Theme} from "@emotion/react";

import {calculateRemSize, flex, flexDirection, mb} from "@pg-design/helpers-css";
import {form, IFormProps} from "@pg-mono/form";

import {SearchFiltersRooms} from "../../../search/components/filters/SearchFiltersRooms";
import {IFilterChildProps, RangeFilter} from "../../../search/components/filters/SearchRangeFilter";
import {DropdownToOpen} from "../../../search/constants/DropdownToOpen";
import {getRoomLabel} from "../../../search/utils/room_field_data_translations";
import {IPropertyConfiguratorSearchFiltersFormValues} from "../../reducers/property_configurator_reducer";

interface IOwnProps {
    singleChoice?: boolean;
}
interface IProps extends IFormProps<IPropertyConfiguratorSearchFiltersFormValues>, IOwnProps {}

export const RoomFilterC = (props: IProps) => {
    const roomsProps = props.getFieldProps("rooms");

    const {singleChoice} = props;
    return (
        <div css={[inputContainer, roomInput]}>
            <RangeFilter
                label="Pokoje"
                id="roomFilter"
                getLabel={getRoomLabel}
                labelId="room-filter-field"
                errorOnBottom
                isDropdownOpened
                toggleDropdown={() => null}
                dropdownName={DropdownToOpen.ROOMS}
                isMobileWidth
                noDropdown
                {...roomsProps}
            >
                {(props: IFilterChildProps<number | "">) => (
                    <SearchFiltersRooms {...props} singleChoice={singleChoice} propertyConfiguratorInput showFooter={false} />
                )}
            </RangeFilter>
        </div>
    );
};

export const RoomFilter = form<IPropertyConfiguratorSearchFiltersFormValues, IProps>(RoomFilterC);

const inputContainer = (theme: Theme) => css`
    ${flex("flex-start")};
    ${flexDirection("column")};

    > label > p {
        ${mb(1)};
        color: ${theme.colors.gray[700]};
    }
`;

const roomInput = (theme: Theme) => css`
    width: 100%;
    max-width: 560px;

    > ul {
        width: 100%;
    }

    li > div {
        height: ${calculateRemSize(6)};
        width: 100%;
        max-width: 112px;
        border-color: ${theme.colors.gray[600]} !important;
    }

    @media (max-width: ${theme.breakpoints.xs}) {
        ul {
            ${mb(0)};
        }
    }
`;
import {css, Theme} from "@emotion/react";

import {calculateRemSize, flex, flexDirection, mb} from "@pg-design/helpers-css";
import {form, IFormProps} from "@pg-mono/form";

import {SearchFiltersRooms} from "../../../search/components/filters/SearchFiltersRooms";
import {IFilterChildProps, RangeFilter} from "../../../search/components/filters/SearchRangeFilter";
import {DropdownToOpen} from "../../../search/constants/DropdownToOpen";
import {getRoomLabel} from "../../../search/utils/room_field_data_translations";
import {IPropertyConfiguratorSearchFiltersFormValues} from "../../reducers/property_configurator_reducer";

interface IOwnProps {
    singleChoice?: boolean;
}
interface IProps extends IFormProps<IPropertyConfiguratorSearchFiltersFormValues>, IOwnProps {}

export const RoomFilterC = (props: IProps) => {
    const roomsProps = props.getFieldProps("rooms");

    const {singleChoice} = props;
    return (
        <div css={[inputContainer, roomInput]}>
            <RangeFilter
                label="Pokoje"
                id="roomFilter"
                getLabel={getRoomLabel}
                labelId="room-filter-field"
                errorOnBottom
                isDropdownOpened
                toggleDropdown={() => null}
                dropdownName={DropdownToOpen.ROOMS}
                isMobileWidth
                noDropdown
                {...roomsProps}
            >
                {(props: IFilterChildProps<number | "">) => (
                    <SearchFiltersRooms {...props} singleChoice={singleChoice} propertyConfiguratorInput showFooter={false} />
                )}
            </RangeFilter>
        </div>
    );
};

export const RoomFilter = form<IPropertyConfiguratorSearchFiltersFormValues, IProps>(RoomFilterC);

const inputContainer = (theme: Theme) => css`
    ${flex("flex-start")};
    ${flexDirection("column")};

    > label > p {
        ${mb(1)};
        color: ${theme.colors.gray[700]};
    }
`;

const roomInput = (theme: Theme) => css`
    width: 100%;
    max-width: 560px;

    > ul {
        width: 100%;
    }

    li > div {
        height: ${calculateRemSize(6)};
        width: 100%;
        max-width: 112px;
        border-color: ${theme.colors.gray[600]} !important;
    }

    @media (max-width: ${theme.breakpoints.xs}) {
        ul {
            ${mb(0)};
        }
    }
`;
